import React from 'react';

const Employees = (extraStyles?: React.CSSProperties) => {
    return (
        <svg width="20" height="18" viewBox="0 0 20 18" fill="inherit" xmlns="http://www.w3.org/2000/svg" style={extraStyles}>
            <path d="M16 12H14V14H16M16 8H14V10H16M18 16H10V14H12V12H10V10H12V8H10V6H18M8 4H6V2H8M8 8H6V6H8M8 12H6V10H8M8 16H6V14H8M4 4H2V2H4M4 8H2V6H4M4 12H2V10H4M4 16H2V14H4M10 4V0H0V18H20V4H10Z" />
        </svg>
    );
};

export default Employees;
